var map = {
	"./img_1.jpg": 18373,
	"./img_2.jpeg": 89217,
	"./img_3.jpg": 47123,
	"./img_4.jpg": 99257,
	"./img_5.jpg": 85473,
	"./img_6.jpg": 4864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73943;